import { APIs } from "../api/APIs";
import { api } from "../api";

export const useFile = () => {
  const downloadFile = async (file) => {
    const urlDownload = `/api/file/${file.fileAccessToken}?download=true`;

    try {
      const response = await fetch(urlDownload, { method: "GET" });
      if (!response.ok) throw new Error("Failed to download file");

      const blob = await response.blob();
      let filename = file.fileName;

      const prefixes = ["[EN]", "[KR]"];
      prefixes.forEach((prefix) => {
        if (filename.startsWith(prefix)) {
          filename = filename.slice(prefix.length);
        }
      });

      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const getFileUploadUrl = async (boardCode, isComment = false) => {
    const api_info = APIs.file.get_upload_url(boardCode, isComment);
    const res = await api(api_info);
    return res.data;
  };

  return {
    downloadFile,
    getFileUploadUrl,
  };
};
